<template>
  <span>
    <template v-for="(part, i) in parts" :key="i">
      <span v-if="part.highlight" class="bg-warning">{{ part.text }}</span>
      <span v-else>{{ part.text }}</span>
    </template>
  </span>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  text: { type: [String, Number, null], default: "" },
  query: { type: String, default: "" },
});

/**
 * normalize:
 * - string
 * - bez diakritiky
 */
const normalize = (str) =>
  String(str ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const parts = computed(() => {
  const rawText = String(props.text ?? "");
  const q = (props.query ?? "").trim();

  if (!rawText || !q) {
    return [{ text: rawText, highlight: false }];
  }

  const normText = normalize(rawText);
  const normQuery = normalize(q);

  // prázdný normalizovaný dotaz -> bez highlightu
  if (!normQuery) {
    return [{ text: rawText, highlight: false }];
  }

  const lowerText = normText.toLowerCase();
  const lowerQuery = normQuery.toLowerCase();

  const result = [];
  let idx = 0;

  while (idx < rawText.length) {
    const foundAt = lowerText.indexOf(lowerQuery, idx);

    if (foundAt === -1) {
      result.push({ text: rawText.slice(idx), highlight: false });
      break;
    }

    if (foundAt > idx) {
      result.push({ text: rawText.slice(idx, foundAt), highlight: false });
    }

    const end = foundAt + lowerQuery.length;
    result.push({ text: rawText.slice(foundAt, end), highlight: true });

    idx = end;
  }

  return result.length ? result : [{ text: rawText, highlight: false }];
});
</script>